import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { GatedContentForm, ProgressButton } from 'components';

// TODO: fix bug with checkboxes
// TODO: save code to localstorage
const GatedContentDialog = ({ formOpen, toggleMemberForm, handleChange, handleGenerate }) => {
	return (
		<Dialog
			maxWidth={'md'}
			fullWidth={true}
			open={formOpen}
			onClose={toggleMemberForm}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">Gated Content</DialogTitle>
			<DialogContent>
				<p>
					Select the Member Types you would like to allow. The generated code will enable any "current" member
					with the selected type access to the page. If no types are selected, all current members will be
					granted access.
				</p>
				<DialogContentText id="alert-dialog-description">
					<GatedContentForm handleChange={handleChange} />
				</DialogContentText>
			</DialogContent>
			<DialogActions
				sx={{
					marginInline: '24px',
					marginBottom: '12px'
				}}
			>
				<Button variant="contained" color="inherit" onClick={toggleMemberForm}>
					Close
				</Button>
				{/* ? Currently we update redux state on checkbox change event. Do we need to update it only on generate click? */}
				{/* <ProgressButton
					circleColor="secondary"
					button={
						<Button onClick={handleGenerate} variant="contained" color="primary" autoFocus>
							Generate
						</Button>
					}
				/> */}
			</DialogActions>
		</Dialog>
	);
};

export default GatedContentDialog;
